import './index.css'
import * as React from 'react'
import { getEmailHandleFromAngularBrackets } from '@disco/utils/email'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import Checkbox from 'components/ui/checkbox'
import DiscoModal from 'components/ui/disco-modal'
const mockData = {
  full_name: 'Test User',
}
export default class TestEmailDialog extends React.Component<
  {
    showSampleDataCheckbox: boolean
    testRecipient:
      | {
          name: string
        }
      | null
      | undefined
    modalState: {
      sending: boolean
      errorMessage: string | null | undefined
    }
    onSubmit: (value: string, mockData: any) => unknown
    onCancel: () => unknown
  },
  {
    sendMockData: boolean
  }
> {
  state: {
    sendMockData: boolean
  } = {
    sendMockData: this.props.showSampleDataCheckbox,
  }
  _inputRef: HTMLInputElement | null | undefined = null
  _handleConfirm: () => void = () => {
    const input = this._inputRef
    if (!input) return
    const value = input.value
    const { email } = getEmailHandleFromAngularBrackets(value)
    const { testRecipient } = this.props
    const data = testRecipient
      ? {
          full_name: testRecipient.name,
        }
      : mockData
    this.props.onSubmit(email, this.state.sendMockData ? data : undefined)
  }

  _renderError(): null | React.ReactElement<'div'> {
    const { errorMessage } = this.props.modalState
    if (!errorMessage) return null
    return <div className="TestEmailDialog_Error">{errorMessage}</div>
  }

  toggleMockData: () => void = () =>
    this.setState({
      sendMockData: !this.state.sendMockData,
    })

  render(): React.ReactNode {
    const message = 'Enter email:'
    const caption = 'Send test email'
    const input = (
      <input
        className="Form_Input CampaignDetails_Input"
        placeholder="test@example.com"
        name="email"
        ref={n => {
          this._inputRef = n
        }}
      />
    )
    const sendButton = (
      <Button
        appearance="primary"
        onClick={this._handleConfirm}
        caption="Send"
        progressIndicator={this.props.modalState.sending}
        progressCaption="Sending"
      />
    )
    const { testRecipient } = this.props
    const name = testRecipient ? testRecipient.name : mockData.full_name
    return (
      <DiscoModal contentLabel={caption} onRequestClose={this.props.onCancel}>
        <div className="Form">
          <h1 className="Form_Header">{caption}</h1>
          <div>{message}</div>
          {input}
          {this._renderError()}
          {this.props.showSampleDataCheckbox && (
            <Checkbox
              checked={this.state.sendMockData}
              onChange={this.toggleMockData}
              className="test-send__checkbox"
              label={`Include sample user data (${name})`}
            />
          )}
          <DialogFooter
            footerMargin={16}
            primary={sendButton}
            onClose={this.props.onCancel}
          />
        </div>
      </DiscoModal>
    )
  }
}
